import { createIcon } from '@chakra-ui/icons';

export const PaperPlane2 = createIcon({
  displayName: 'PaperPlane2',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" clipPath="url(#clip0_3390_2221)">
        <path
          d="M12.5404 1.45874L4.08203 7.51082V12.2504L6.9987 9.69832"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
        />
        <path
          d="M1.45703 5.54207L12.5404 1.45874L10.7904 12.5421L1.45703 5.54207Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_3390_2221">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
